
/*
 * https://developerx.atlassian.net/browse/CS-4951
 *
 * Created at : 09 Feb 2022           Updated at : 09 Feb 2022
 * Created by : Risman Abdilah        Updated by : Risman Abdilah
 *
 * Version 2.3.0
 */

import Vue from "vue";
import filters from "@/filters";
import Component from "vue-class-component";
import { State } from "vuex-class";
import { Prop } from "vue-property-decorator";

import { CandidateModel } from "@/models/candidate.model";

@Component({ filters })
export default class ModalPersonality extends Vue {
  /* VUEX */

  /* ACTION */

  /* PROP */
  @Prop({ default: false })
  private isShow: boolean;

  /* STATE */
  @State("locale")
  private locale: any;
  @State("candidate", { namespace: "candidate" })
  private candidate: CandidateModel;

  /* INITIALIZATION */
  private personalityValue = "";

  private personality_temporary: any[] = [];
  private array_personality: Array<any> = [];

  /* METHODS */

  private onSubmit() {
    this.$emit("update:isShow", false);
  }

  private selectedItem(item: any) {
    let itemId = item.id;
    return this.array_personality.includes(itemId);
  }

  private clickItem(item: any) {
    let index = this.array_personality.indexOf(item.id);
    if (index < 0) {
      this.array_personality.push(item.id);
      this.personality_temporary.push(item);
    } else {
      this.personality_temporary.splice(index, 1);
      this.array_personality.splice(index, 1);
    }
    this.personalityValue = "";
  }
}
